import { jsx as i, jsxs as e } from "react/jsx-runtime";
import { Row as j, Col as z } from "antd";
import { memo as G, useState as H } from "react";
import { u as t } from "../../../styled-components.browser.esm-BFmoFexH.js";
import { d as L } from "../../../index-a388f2ac-Cf1pu7LW.js";
import { useHasDisplayOptionApplied as P } from "../../../metricDisplay/MetricDisplay.hooks.js";
import { IconContainer as M, ContentCol as E, FlexMetricOptionRow as d, DeleteContainer as S } from "@biron-data/react-components";
import { F as _ } from "../../../XCircleIcon-C46OdWM6.js";
import { E as q } from "../../../utils-wNl4DVdv.js";
import { MetricOptionsFormKeys as R, ColorTypes as B } from "../options/MetricOptionForm.types.js";
import { useLanguageResolver as J } from "@biron-data/react-contexts";
import { strToColor as p } from "../../../configuration/types.js";
import { g as N } from "../../../GradientSelector.utils-BKTc3JRX.js";
const ar = G(({
  value: r,
  setActiveKey: o,
  onDelete: n,
  iconSize: O,
  iconSpan: I
}) => {
  var a, l, m, x, g, h, C, $, b, k, y, D, w, F;
  const c = J(), [T, f] = H(!1), W = P(r), s = q(o);
  return /* @__PURE__ */ i(A, { children: W && /* @__PURE__ */ i(K, { children: /* @__PURE__ */ i(Z, { children: /* @__PURE__ */ e(j, { children: [
    /* @__PURE__ */ i(z, { span: I, onClick: () => {
      o == null || o(R.display);
    }, children: /* @__PURE__ */ i(U, { $clickable: s, children: /* @__PURE__ */ i(M, { size: O, children: /* @__PURE__ */ i(L.Display, {}) }) }) }),
    /* @__PURE__ */ i(E, { span: 19, onClick: () => {
      o == null || o(R.display);
    }, children: /* @__PURE__ */ e(Q, { children: [
      ((a = r == null ? void 0 : r.extraConf) == null ? void 0 : a.decimals) && /* @__PURE__ */ e(
        d,
        {
          $clickable: s,
          onMouseOver: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ e("span", { children: [
              c.get("configuration-metric-options.display.decimals"),
              ": ",
              r.extraConf.decimals
            ] }),
            T && n && /* @__PURE__ */ i(S, { children: /* @__PURE__ */ i(M, { clickable: !0, size: 14, color: "var(--light-grey)", children: /* @__PURE__ */ i(_, { onClick: () => n(["decimals", "details", "units", "color"]) }) }) })
          ]
        }
      ),
      (((l = r == null ? void 0 : r.extraConf) == null ? void 0 : l.units) || ((m = r == null ? void 0 : r.extraConf) == null ? void 0 : m.details)) && /* @__PURE__ */ i(d, { $clickable: s, children: /* @__PURE__ */ e("span", { children: [
        c.get("configuration-metric-options.display.details.title"),
        ": ",
        r.extraConf.units,
        " ",
        ((g = (x = r == null ? void 0 : r.extraConf) == null ? void 0 : x.details) == null ? void 0 : g.type) === "prefix" ? `${(h = r == null ? void 0 : r.extraConf) == null ? void 0 : h.details.value} -` : `- ${(($ = (C = r == null ? void 0 : r.extraConf) == null ? void 0 : C.details) == null ? void 0 : $.value) ?? ""}`
      ] }) }),
      (((b = r == null ? void 0 : r.extraConf) == null ? void 0 : b.color) || ((k = r == null ? void 0 : r.extraConf) == null ? void 0 : k.interval) || ((y = r == null ? void 0 : r.extraConf) == null ? void 0 : y.gradient)) && /* @__PURE__ */ i(d, { $clickable: s, children: /* @__PURE__ */ e(
        d,
        {
          $clickable: s,
          children: [
            /* @__PURE__ */ i("span", { children: c.get(`configuration-metric-options.display.color.${((D = r == null ? void 0 : r.extraConf) == null ? void 0 : D.type) ?? B.fixed}`, (F = (w = r == null ? void 0 : r.extraConf) == null ? void 0 : w.interval) == null ? void 0 : F.step) }),
            r.extraConf.color && /* @__PURE__ */ i(V, { $color: r.extraConf.color }),
            r.extraConf.interval && /* @__PURE__ */ i(
              X,
              {
                $firstColor: r.extraConf.interval.firstColor,
                $secondColor: r.extraConf.interval.secondColor
              }
            ),
            r.extraConf.gradient && /* @__PURE__ */ i(Y, { $colors: N(r.extraConf.gradient.type, r.extraConf.gradient.base) })
          ]
        }
      ) })
    ] }) })
  ] }) }) }) });
}), Q = t.div`
    display: flex;
    flex-direction: column;
    gap: 3px;
`, U = t(d)`
    height: auto;
`, V = t.div`
    width: 10px;
    height: 10px;
    border-radius: 3px;
    background-color: ${({ $color: r }) => p.get(r)};
    margin-left: 5px;
`, X = t.div`
    width: 70px;
    height: 10px;
    border-radius: 3px;
    ${({ $firstColor: r, $secondColor: o }) => `background: linear-gradient(90deg, ${p.get(r)} 50%, ${p.get(o)} 50%);`}
    margin-left: 5px;
`, Y = t.div`
    width: 70px;
    height: 10px;
    border-radius: 3px;
    ${({ $colors: r }) => `
      background: ${r[0]};
      background: linear-gradient(90deg, ${Array.from({ length: r.length }, (o, n) => Math.round(n * 100 / (r.length - 1))).map((o, n) => `${r[n]} ${o}%`)});
    `}
    margin-left: 5px;
`, Z = t.div`
    display: flex;
    flex-direction: column;
`, A = t.div`
    width: 100%;
    cursor: pointer;
`, K = t.div`
    align-items: center;
    gap: 10px;
`;
export {
  ar as default
};
//# sourceMappingURL=MetricDisplayResume.js.map
